import * as React from 'react';

import styles from './modal-header.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

ModalHeader.defaultProps = {
    as: 'div',
};

export function ModalHeader({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['modal-header']}>{children}</Tag>;
}
